import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { ActorListItem, EntitiesEnum, Team, TeamListItem } from '@match-fix/shared';

import { Configuration } from '../configuration';
import { CrudService } from '../crud.service';
import { BASE_PATH } from '../variables';

@Injectable({
  providedIn: 'root'
})
export class TeamsService extends CrudService<Team> {
  constructor(public httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration) {
    super(EntitiesEnum.Teams, httpClient, basePath, configuration);
  }

  /**
   * Function to get all match team players
   */
  async getMatchTeamPlayers(matchId: number): Promise<ActorListItem[]> {
    const headers = this.defaultHeaders;
    const url = this.getEntityServiceEndpoint();
    return this.httpClient.get<ActorListItem[]>(
      `${url}/players?matchId=${matchId}`, {
      withCredentials: true,
      headers,
      observe: 'body',
      reportProgress: false
    }
    ).toPromise<ActorListItem[]>();
  }

  async getMatchTeams(matchId: number): Promise<Team[]> {
    const headers = this.defaultHeaders;
    const url = this.getEntityServiceEndpoint();
    return this.httpClient.get<Team[]>(
      `${url}/matches?matchId=${matchId}`, {
      withCredentials: true,
      headers,
      observe: 'body',
      reportProgress: false
    }
    ).toPromise<Team[]>();
  }

  /**
  * Function to get all teams by matchId
  */
  async getTeamsByMatch(matchId: number): Promise<TeamListItem[]> {
    const headers = this.defaultHeaders;
    const url = this.getEntityServiceEndpoint();
    return this.httpClient.get<TeamListItem[]>(
      `${url}/getTeamsByMatch?matchId=${matchId}`, {
      withCredentials: true,
      headers,
      observe: 'body',
      reportProgress: false
    }
    ).toPromise<TeamListItem[]>();
  }
}
